export default __webpack_public_path__ + "static/media/440.b67853b7.png";